import React from 'react';
import PropTypes from 'prop-types';

const ColorCell = ({ 
  value, 
  globalMaxValue,
  globalMinValue, 
  metricType, 
  formatConfig,
  className = "text-center retention-cell",
  style = {},
  positiveColor = { r: 40, g: 120, b: 189 }, 
  negativeColor = { r: 189, g: 40, b: 40 },
  decimal = 2  
}) => {
  
  const formatNumber = (num) => {
    if (num === null || num === undefined || num === '' || isNaN(num) || num === '0' || num === 0) {
      return `0`;
    }
    const safeNum = Number(num);
    return safeNum.toLocaleString("en-US", { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: decimal 
    });
  };

  const formatMetricValue = (val) => {
    const config = formatConfig || {};
    const formattedNumber = formatNumber(val);
    return `${config.prefix || ''}${formattedNumber}${config.suffix || ''}`;
  };

  const getCellStyle = () => {
    
    if (value === null || value === undefined || value === '' || isNaN(value)) {
      return {
        backgroundColor: 'transparent',
        border: '1px solid #f0f0f0'
      };
    }

    const numericValue = parseFloat(value);
    
    
    if (numericValue === 0) {
      return {
        backgroundColor: 'white',
        border: '1px solid #f0f0f0'
      };
    }
    
    
    if (numericValue < 0) {
      if (!globalMinValue || globalMinValue >= 0) return { backgroundColor: 'transparent' };
      
      const ratio = Math.abs(numericValue) / Math.abs(globalMinValue);
      const r = Math.floor(240 - (240 - negativeColor.r) * ratio);
      const g = Math.floor(220 - (220 - negativeColor.g) * ratio);
      const b = Math.floor(200 - (200 - negativeColor.b) * ratio);
      
      return {
        backgroundColor: `rgb(${r}, ${g}, ${b})`,
        borderLeft: "none",
        borderRight: "none",
      };
    }
    
    
    if (numericValue > 0) {
      if (!globalMaxValue || globalMaxValue <= 0) return { backgroundColor: 'transparent' };
      
      const ratio = numericValue / globalMaxValue;
      const r = Math.floor(200 - (200 - positiveColor.r) * ratio);
      const g = Math.floor(220 - (220 - positiveColor.g) * ratio);
      const b = Math.floor(240 - (240 - positiveColor.b) * ratio);
      
      return {
        backgroundColor: `rgb(${r}, ${g}, ${b})`,
        borderLeft: "none",
        borderRight: "none",
      };
    }
    
    return {
      backgroundColor: 'transparent',
      border: '1px solid #f0f0f0'
    };
  };

  const cellStyle = getCellStyle();
  const numericValue = parseFloat(value) || 0;
  const absoluteValue = Math.abs(numericValue);
  const maxAbsoluteValue = Math.max(Math.abs(globalMinValue || 0), Math.abs(globalMaxValue || 0));
  const relativeValue = maxAbsoluteValue > 0 ? absoluteValue / maxAbsoluteValue : 0;

  return (
    <td 
      className={className}
      style={{ 
        ...cellStyle,
        ...style,
        color: (relativeValue > 0.6) ? 'white' : '#333',
        
      }}
      data-export-value={value}
      data-export-type={((formatConfig || {}).suffix === '%') ? 'percent' : 'number'}
    >
      {formatMetricValue(value)}
    </td>
  );
};

ColorCell.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  globalMaxValue: PropTypes.number,
  globalMinValue: PropTypes.number,
  metricType: PropTypes.string,
  formatConfig: PropTypes.shape({
    prefix: PropTypes.string,
    suffix: PropTypes.string
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  positiveColor: PropTypes.shape({ 
    r: PropTypes.number,
    g: PropTypes.number,
    b: PropTypes.number
  }),
  negativeColor: PropTypes.shape({ 
    r: PropTypes.number,
    g: PropTypes.number,
    b: PropTypes.number
  })
};

ColorCell.defaultProps = {
  value: 0,
  metricType: 'retention',
  formatConfig: {
    prefix: '',
    suffix: ''
  },
  className: "text-center retention-cell",
  style: {},
  positiveColor: { r: 40, g: 120, b: 189 },
  negativeColor: { r: 189, g: 40, b: 40 }
};

export default ColorCell;